"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Payment_API_PATH = exports.PaymentPath = void 0;
const payment = "/payment";
exports.PaymentPath = {
    payment,
};
const api_prefix = "api";
const handlePath = ({ path }) => {
    const apiPath = {
        frontend: `${api_prefix}${exports.PaymentPath.payment}/${path}`,
        backend: `/${path}`,
    };
    return apiPath;
};
exports.Payment_API_PATH = {
    walletAddFund: handlePath({
        path: `initiate/add_found`,
    }),
    orderPayment: handlePath({
        path: `initiate/order`,
    }),
    list: handlePath({
        path: `/`,
    }),
    initiate: handlePath({
        path: "initiate",
    }),
    paystackRetryPayment: handlePath({
        path: "paystack/retry_payment",
    }),
    sendPayment: handlePath({
        path: "send_payment",
    }),
    paymentByWallet: handlePath({
        path: `wallet/`,
    }),
    getPaymentByOrder: (orderId) => handlePath({
        path: `order/${orderId}`,
    }),
    getByPaymentNumber: (paymentNumber) => handlePath({
        path: `number/${paymentNumber}`,
    }),
    verifyPayment: (paymentNumber) => handlePath({
        path: `verify/${paymentNumber}`,
    }),
    getPayment: (id) => handlePath({
        path: `${id}`,
    }),
    getPaymentUsableData: handlePath({
        path: `usable`,
    }),
    discardPaymentUsableRedis: handlePath({
        path: `discard_redish`,
    }),
    savePaymentUsableData: handlePath({
        path: `save_usable`,
    }),
    getPendingPaymentUrl: (paymentNumber) => handlePath({
        path: `pending_url/` + paymentNumber,
    }),
};
//# sourceMappingURL=payment.js.map